import { LayoutHOC } from 'base/ui/layout/layout';
import { campaignRoutes } from './routes';
import createContentManage from './ContentManage';
import createCampaignManage from './CampaignManage';
import createAddContent from './ContentManage/detail';
import createAddCampaign from './CampaignManage/ceateCampaign';
// import {} from './CampaignManage/detail';

export const createCampaignPage = (layoutHOC: LayoutHOC) => {
  // -- Quản lý nội dung  --------------------------------------
  const ContentManage = createContentManage();
  // Thêm mới
  const AddContent = createAddContent();
  // Chỉnh sủa
  const EditContent = createAddContent();

  // -- Quản lý chiến dịch --------------------------------------
  const CampaignManage = createCampaignManage();
  // Thêm mới
  const AddCampaign = createAddCampaign();
  // Chỉnh sửa
  const EditCampaign = createAddCampaign();

  const CompaignPage = layoutHOC(campaignRoutes);

  return () => (
    <CompaignPage
      ContentManage={ContentManage}
      AddContent={AddContent}
      EditContent={EditContent}
      CampaignManage={CampaignManage}
      AddCampaign={AddCampaign}
      EditCampaign={EditCampaign}
    />
  );
};
